<div class="user-profile">
  <div class="profile-content">
    <div class="avatar-container">
      <img
        *ngIf="hasAvatar" 
        [src]="'data:image/jpeg;base64,' + user?.avatarImage" 
        [alt]="displayName"
        class="avatar-image"
      />
      <div *ngIf="!hasAvatar && displayName" class="avatar-initial">
        {{ avatarInitials }} 
      </div>
    </div>
    <div class="user-info">
      <div class="user-name" *ngIf="displayName">{{ displayName }}</div>
    </div>
  </div>
</div> 